@switch (status) {
  @case (RequisitionStatus.Draft) {
    <rt-badge [text]="'app.requisitions.status.draft' | translate" [color]="'counter-default'" />
  }
  @case (RequisitionStatus.Pending) {
    <rt-badge
      [text]="'app.requisitions.status.pending' | translate"
      [color]="isArchived ? 'counter-default' : 'requested-tint'"
      iconName="timer-sand"
    />
  }
  @case (RequisitionStatus.Rejected) {
    <rt-badge
      [text]="'app.requisitions.status.rejected' | translate"
      [color]="isArchived ? 'counter-default' : 'rejected-tint'"
      iconName="block"
    />
  }
  @case (RequisitionStatus.Approved) {
    <rt-badge
      [text]="'app.requisitions.status.approved' | translate"
      [color]="isArchived ? 'counter-default' : 'success-tint'"
      iconName="check"
    />
  }
  @case (RequisitionStatus.Filled) {
    <rt-badge
      [text]="'app.requisitions.status.filled' | translate"
      [color]="isArchived ? 'counter-default' : 'success-tint'"
      iconName="hired"
    />
  }
}
